import { Component, Input, ElementRef, AfterViewInit, ViewChild } from "@angular/core";
import { IUProperty } from "../lib/public_api";
import { ILinkTyped } from "src/app/shared/interface/link";
import { ILicenseV3Items } from "./components/license-panel-item/license-panel-item.component";
import { MqService } from "src/app/service/mq.service";
import { SimplebarAngularComponent } from "simplebar-angular";
import { applyTitleSettings } from '../../shared/utils/title-style-settings-utils';
import { ITitleStyleSettings } from '../../shared/interface/title-style-settings';
import { IRteStyleSettings } from "../../shared/interface/rte-style-settings";
import { applyRteSettings } from "../../shared/utils/rte-style-settings-utils";

interface ILicenseV3PanelData {
  title: IUProperty<string>;
  linkToComparisonDocument: IUProperty<ILinkTyped>;
  linkToComparisonPage: IUProperty<ILinkTyped>;
  description: IUProperty<string>;
  items: IUProperty<ILicenseV3Items[]>;
  textAfter: IUProperty<string>;
  textAfterFontWeight: IUProperty<string>;
  textAfterFontSize: IUProperty<string>;
  textAfterFontColor: IUProperty<string>;
  link: IUProperty<ILinkTyped>;
  linkColor: IUProperty<string>;

  rteStyleSettingsComposition?: IRteStyleSettings;
  titleStyleSettings?: ITitleStyleSettings;
}

@Component({
  selector: "app-license-v3-panel",
  templateUrl: "./license-v3-panel.component.html",
  styleUrls: ["./license-v3-panel.component.less"],
})
export class LicenseV3PanelComponent implements AfterViewInit {
  @Input() data: ILicenseV3PanelData;
  @ViewChild('scrollEl', { static: false }) scrollEl: SimplebarAngularComponent;
  @ViewChild('titleEl', { static: false }) titleEl: ElementRef<HTMLElement>;
  @ViewChild('descriptionEl', { static: false }) descriptionEl: ElementRef<HTMLElement>;
  @ViewChild('textAfterEl', { static: false }) textAfterEl: ElementRef<HTMLElement>;

  scrollBarOptions = { autoHide: false, scrollbarMinSize: 100 };

  constructor(private hostRef: ElementRef, private mq: MqService) { }

  ngAfterViewInit(): void {
    this.applyCustomTheme();

    if (this.mq.isMidi()) {
      this.scrollToFocusedItem();
    }
  }

  navigateToAnchor(url: string): void {
    const anchorName = url.split("#");
    document.getElementById(anchorName[anchorName.length - 1]).scrollIntoView({
      behavior: "smooth",
      block: "start",
      inline: "start",
    });
  }

  applyCustomTheme() {
    applyTitleSettings(this.data, this.titleEl);
    applyRteSettings(this.data, this.descriptionEl);

    if (this.textAfterEl && this.data.textAfter && this.data.textAfter.value) {
      if (this.data.textAfterFontColor && this.data.textAfterFontColor.value) {
        this.textAfterEl.nativeElement.style.setProperty("--licence-v3-text-after-font-color",
          this.data.textAfterFontColor.value);
      }
      if (this.data.textAfterFontSize && this.data.textAfterFontSize.value) {
        this.textAfterEl.nativeElement.style.setProperty("--licence-v3-text-after-font-size",
          this.data.textAfterFontSize.value + 'px');
      }
      if (this.data.textAfterFontWeight && this.data.textAfterFontWeight.value) {
        this.textAfterEl.nativeElement.style.setProperty("--licence-v3-text-after-font-weight",
          this.data.textAfterFontWeight.value);
      }
    }
  }

  private scrollToFocusedItem() {
    const focusedItem = document.querySelector(".focused-license");

    if (focusedItem) {
      const middleScreenWidth = window.screen.width / 2;
      const focusedItemRects = focusedItem.getClientRects()[0];
      const scrollContainer = this.scrollEl.SimpleBar.contentWrapperEl;

      scrollContainer.scrollTo({
        left:
          focusedItemRects.left -
          middleScreenWidth +
          focusedItemRects.width / 2,
        behavior: "smooth",
      });
    }
  }
}
